import { Link } from 'react-router-dom';
import { 
  FaHome, 
  FaCar, 
  FaBuilding, 
  FaUser, 
  FaStore,
  FaUserTie,
  FaBriefcase,
  FaRocket,
  FaCheckCircle,
  FaCalculator,
  FaPhoneAlt
} from 'react-icons/fa';

const Services = () => {
  const loanProducts = [
    {
      id: 1,
      icon: <FaHome />,
      title: "Home Loan",
      loanTypeValue: "Home",
      description: "Your dream home is just a step away",
      features: ["Interest rates from 7.5%", "Loan up to ₹5 Crores", "Tenure up to 20 years", "Minimal documentation"],
      amount: "Up to ₹5 Crores",
      rate: "7.5% onwards"
    },
    {
      id: 2,
      icon: <FaCar />,
      title: "Car Loan",
      loanTypeValue: "Car",
      description: "Drive your dream car with our hassle-free auto financing solutions",
      features: ["Quick approval in 2 hours", "Tenure up to 5 years", "Flexible EMI options", "No hidden charges"],
      amount: "Up to ₹1 Crore",
      rate: "9.5% onwards"
    },
    {
      id: 3,
      icon: <FaBuilding />,
      title: "Loan Against Property",
      loanTypeValue: "Loan Against Property",
      description: " Utilize your assets for your benifit",
      features: ["Interest rates from 8.5%", "Tenure up to 15 years", "High loan amount", "Minimal documentation"],
      amount: "Up to ₹10 Crores",
      rate: "8.5% onwards"
    },
    {
      id: 4,
      icon: <FaStore />,
      title: "Business Loan",
      loanTypeValue: "Business",
      description: " Fuel your business growth.",
      features: ["Working capital support", "Equipment financing", "Quick disbursement", "Collateral-free options"],
      amount: "Up to ₹10 Crores",
      rate: "11% onwards"
    },
    {
      id: 5,
      icon: <FaUser />,
      title: "Personal Loan",
      loanTypeValue: "Personal",
      description: "Quick funds for your personal needs.",
      features: ["Instant approval", "No collateral required", "Tenure up to 3 years", "Competitive rates"],
      amount: "Up to ₹50 Lakhs",
      rate: "9.5% onwards"
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="content-wrapper">
          <div className="services-hero-content">
            <h1>Thank you for choosing us to assist with your financial needs!</h1>
            <p>We’re committed to making your loan journey easy and stress-free. Here are the options we offer to help you achieve your goals</p>
            <div className="hero-stats">
              <div className="stat-item">
                <h3>₹1000+ Cr</h3>
                <p>Loans Disbursed</p>
              </div>
              <div className="stat-item">
                <h3>50,000+</h3>
                <p>Happy Customers</p>
              </div>
              <div className="stat-item">
                <h3>5 Min</h3>
                <p>Quick Approval</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Loan Products Grid */}
      <section className="loan-products">
        <div className="content-wrapper">
          <div className="section-header">
            <h2>Choose Your Perfect Loan</h2>
            <p>Explore our comprehensive range of loan products designed to meet your specific financial requirements</p>
          </div>
          
          <div className="products-grid">
            {loanProducts.map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-icon">
                  {product.icon}
                </div>
                <h3>{product.title}</h3>
                <p className="product-description">{product.description}</p>
                
                <div className="product-details">
                  <div className="detail-item">
                    <span className="label">Loan Amount:</span>
                    <span className="value">{product.amount}</span>
                  </div>
                  <div className="detail-item">
                    <span className="label">Interest Rate:</span>
                    <span className="value">{product.rate}</span>
                  </div>
                </div>
                
                <ul className="product-features">
                  {product.features.map((feature, index) => (
                    <li key={index}>
                      <FaCheckCircle />
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <div className="product-actions">
                  <Link 
                    to="/apply" 
                    state={{ 
                      loanType: product.loanTypeValue
                    }}
                    className="btn-primary"
                  >
                    Apply Now
                  </Link>
                  <Link to="/emi-calculator" className="btn-secondary">
                    <FaCalculator /> Calculate EMI
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Types */}
      <section className="customer-types">
        <div className="content-wrapper">
          <div className="section-header">
            <h2>Designed for Every Customer</h2>
            <p>Specialized loan solutions crafted for different customer segments</p>
          </div>
          
          <div className="customer-grid">
            <div className="customer-card">
              <div className="customer-icon">
                <FaUserTie />
              </div>
              <h3>Salaried Professionals</h3>
              <p>Tailored loan products for regular income earners with competitive rates and minimal documentation requirements.</p>
              <div className="customer-benefits">
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Salary-based eligibility assessment</span>
                </div>
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Streamlined documentation process</span>
                </div>
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Quick approval and disbursement</span>
                </div>
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Flexible repayment options</span>
                </div>
              </div>
            </div>
            
            <div className="customer-card">
              <div className="customer-icon">
                <FaBriefcase />
              </div>
              <h3>Business Owners</h3>
              <p>Comprehensive financing solutions for entrepreneurs and business owners across various industries and sectors.</p>
              <div className="customer-benefits">
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Business income evaluation</span>
                </div>
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Customized repayment schedules</span>
                </div>
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Growth-oriented loan products</span>
                </div>
                <div className="benefit-item">
                  <FaCheckCircle />
                  <span>Working capital support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="services-cta">
        <div className="content-wrapper">
          <div className="cta-content">
            <h2>Ready to Apply for a Loan?</h2>
            <p>Get started with your loan application today and experience our seamless, digital-first approach</p>
            <div className="cta-buttons">
              <Link to="/apply" className="cta-button primary">
                <FaRocket /> Start Application
              </Link>
              <a href="tel:+919148942560" className="cta-button secondary">
                <FaPhoneAlt /> Call Us Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;